import { Component, OnInit } from '@angular/core';
import { PrestamosService } from '../../services/prestamos.service';
import { RutasService } from '../../services/rutas.service';
import { AlertasModales } from '../../helpers/alertasModales';
import { ActivatedRoute, Params, Router  } from '@angular/router';
import { Helper } from '../../helpers/helper';
import { CurrencyPipe, LowerCasePipe } from '@angular/common';
import { EmpleadosServicio } from '../../services/empleado.service';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { IMyDrpOptions } from 'mydaterangepicker';

const ID_PAGINA = 10;

@Component({
  selector: 'app-recibos',
  templateUrl: './recibos.component.html',
  styleUrls: ['./recibos.component.css']
})
export class RecibosComponent implements OnInit {
  recibos = [];
  busqueda = '';
  page = 1;
  limit = '50';
  offset = 0;
  size = 0;
  rutas = [];
  rutasSeleccionadas = [];
  rutasSeleccionadasAntes = false;
  loaded = false;
  loading = false;
  exportando = false;
  estado = 0;
  fecha_desde: NgbDateStruct;
  fecha_hasta: NgbDateStruct;
  now = new Date(this.helper.getDate());
  total_pagado = 0;
  empleado: any;
  configPdf;
  resOneWeek  = new Date().setTime(this.now.getTime() + (6 * 24 * 60 * 60 * 1000));
  oneWeek = new Date( this.resOneWeek);
  myDateRangePickerOptions: IMyDrpOptions = {
    dateFormat: 'dd-mm-yyyy',
    showSelectDateText: true,
    selectBeginDateTxt : 'Seleccione la fecha inicial',
    selectEndDateTxt: 'Seleccione la fecha final'
  };

  lowerCasePipe = new LowerCasePipe();
  dropdownSettings: any;
  active: string;
  columnsSort = [];
  private columnsServer = [];
  screenLarge = true;
  constructor(
    private prestamoService: PrestamosService,
    private rutaService: RutasService,
    private modals: AlertasModales,
    private helper: Helper,
    private route: ActivatedRoute,
    private router: Router,
    public empleadoService: EmpleadosServicio
    ) {
    if (empleadoService.datosEmpleado.tipo_empleado !== 3 && !empleadoService.paginasAsignadas.filter(page => page.ID_PAGINA == ID_PAGINA).length) {
      this.router.navigate(['/404']);
    }


    this.screenLarge = !window.matchMedia('(min-width: 1200px)').matches;
    window.onresize = () => this.screenLarge = !window.matchMedia('(min-width: 1200px)').matches;
    this.fecha_desde = {
      year: this.now.getFullYear(),
      month: this.now.getMonth() + 1,
      day: this.now.getDate()
    };
    this.fecha_hasta = {
      year: this.now.getFullYear(),
      month: this.now.getMonth() + 1,
      day: this.now.getDate()
    };
    this.initColumns();
    this.initRutas();
    this.initConfigPdf();
    this.empleado = this.empleadoService.datosEmpleado;
    this.rutasSeleccionadas = rutaService.getSelectedRoutes();
    if (this.rutasSeleccionadas.length > 0) {
      this.rutasSeleccionadasAntes = true;
    }
  }

  ngOnInit() {
    this.initDetalleRecibo();
    if (localStorage.getItem('rutaSeleccionada')) {
      // this.rutaSeleccionada = localStorage.getItem('rutaSeleccionada');
    }
    this.initConfigMultiSelect();
    window.onresize = () => this.initConfigMultiSelect();
  }

  private initConfigMultiSelect() {
    let badgeShowLimit = 1;
    if (window.matchMedia('(min-width: 992px)').matches) {
      badgeShowLimit = 2;
    } else if (window.matchMedia('(max-width: 992px)').matches) {
      badgeShowLimit = 3;
    } else {
      badgeShowLimit = 8;
    }

    this.dropdownSettings = {
      singleSelection: false,
      text: 'Seleccionar zona',
      selectAllText: 'Seleccionar todo',
      unSelectAllText: 'Deseleccionar todo',
      enableSearchFilter: true,
      classes: 'custom-multiselect',
      badgeShowLimit,
      searchPlaceholderText: 'Búsqueda'
    };
  }

  private initRecibos(): void {
    let fecha_desde = '';

    if (this.fecha_desde !== undefined && this.fecha_desde !== null && this.fecha_desde.year !== null) {
      fecha_desde = `${this.fecha_desde.year}-${this.fecha_desde.month}-${this.fecha_desde.day}`;
    }

    let fecha_hasta = '';

    if (this.fecha_hasta !== undefined && this.fecha_hasta !== null && this.fecha_hasta.year !== null) {
      fecha_hasta = `${this.fecha_hasta.year}-${this.fecha_hasta.month}-${this.fecha_hasta.day}`;
    }

    this.loading = true;
    this.prestamoService.obtenerListaRecibos(
      this.limit,
      this.offset,
      this.rutasSeleccionadas.map(data => data.id).join(),
      this.busqueda,
      fecha_desde,
      fecha_hasta,
      this.estado,
      0,
      '',
      JSON.stringify(this.columnsServer),
    ).subscribe((res: any) => {
      this.active = localStorage.getItem('recibo_active') || '';
      this.size = res.total_items;
      this.recibos = res.recibos;
      this.total_pagado = res.total_pagado;
      setTimeout(() => { this.loaded = true; this.loading = false; }, 1);
    });
  }

  private initRutas(): void {
    this.rutas = [];
    this.rutasSeleccionadas = [];
    this.rutaService.cargarTodasLasRutas().subscribe(res => {
      for (const ruta of res.rutas) {
        this.rutas.push({
          id: ruta.ID_RUTA,
          itemName: this.lowerCasePipe.transform(ruta.nombre)
        });
      }
      this.verificarQueryString();
    });
  }

  private initDetalleRecibo(): void {
    this.route.queryParams.subscribe((res: any) => {
      if (res.r) {
        this.prestamoService.detalleRecibo(res.r).subscribe(recibo => {
          if (recibo) {
            this.detalleRecibo(recibo);
          }
        });
      }
    });
  }

  private verificarQueryString(): void {
    this.route.queryParams.subscribe(params => {
      if (params) {
        if (params.rutas) {
          this.rutasSeleccionadas = [];
          for (const ruta of this.rutas) {
            for (const rutaSeleccionada of params.rutas.split(',')) {
              if (parseFloat(rutaSeleccionada) === ruta.id) {
                this.rutasSeleccionadas.push(ruta);
              }
            }
          }
          if (this.rutas.length > 0) {
            this.rutaService.setSelectedRoutes(this.rutasSeleccionadas);
          }
        }
        if  (this.rutasSeleccionadas.length > 0)  {

          this.rutaService.setSelectedRoutes(this.rutasSeleccionadas);
          this.rutasSeleccionadasAntes = false;
        } else {
          if  (this.rutasSeleccionadasAntes) {
            this.rutasSeleccionadas = this.rutaService.getSelectedRoutes();
            this.rutasSeleccionadasAntes = false;
          } else  {
            this.rutaService.removeSelectedRoutes();
          }

        }
        if (params.fecha_desde || params.fecha_hasta) {

          if (params.fecha_desde) {
            const yearInit = parseFloat(params.fecha_desde.split('-')[0]);
            const monthInit = parseFloat(params.fecha_desde.split('-')[1]);
            const dayInit = parseFloat(params.fecha_desde.split('-')[2]);

            if ( !isNaN( yearInit ) && !isNaN( monthInit ) && !isNaN( dayInit ) ) {
              this.fecha_desde = { year: yearInit, month: monthInit, day: dayInit };
            }
          }

          if (params.fecha_hasta) {
            const yearEnd = parseFloat(params.fecha_hasta.split('-')[0]);
            const monthEnd = parseFloat(params.fecha_hasta.split('-')[1]);
            const dayEnd = parseFloat(params.fecha_hasta.split('-')[2]);

            if ( !isNaN( yearEnd ) && !isNaN( monthEnd ) && !isNaN( dayEnd ) ) {
              this.fecha_hasta = { year: yearEnd, month: monthEnd, day: dayEnd };
            }
          }
        }

        if (params.busqueda) {
          this.busqueda = params.busqueda;
        }
        if (params.limite) {
          this.limit = params.limite;
        }
        if (params.page && !isNaN(params.page)) {
          this.page = parseFloat(params.page);
          this.offset = parseFloat(this.limit) * (this.page - 1);
        }
        if (params.mostrar) {
          this.estado = (String(params.mostrar).toLowerCase() === 'todos' ? -1 :
                        (String(params.mostrar).toLowerCase() === 'activos' ? 0 : 1) );
        }
        this.columnsServer = [];
        // tslint:disable-next-line:forin
        for (const columnParams in params) {
          for (const column of this.columnsSort) {
            if (column.label.replace(/\s/g, '').toLowerCase() === columnParams.replace('order', '')) {
              if (params[columnParams].toLowerCase() === 'asc' || params[columnParams].toLowerCase() === 'desc') {
                column.order = params[columnParams].toLowerCase();
                this.columnsServer.push(column);
                break;
              }
            }
          }
        }
        this.initRecibos();
      }
    });
  }

  loadPage(page: number) {
    this.page = page;
     this.offset = parseFloat(this.limit) * (this.page - 1);
     const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
     queryParams['page'] = page;
     this.router.navigate(['./lista/recibos'], { queryParams: queryParams });
  }

  filtrarRecibos() {
    this.page = 1;
    this.offset = 0;

    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    delete queryParams['r'];
    queryParams['limite'] = this.limit;

    if (this.fecha_desde !== undefined && this.fecha_desde !== null && this.fecha_desde.year !== null) {
      queryParams['fecha_desde'] = `${this.fecha_desde.year}-${this.fecha_desde.month}-${this.fecha_desde.day}`;
    }

    if (this.fecha_hasta !== undefined && this.fecha_hasta !== null && this.fecha_hasta.year !== null) {
      queryParams['fecha_hasta'] = `${this.fecha_hasta.year}-${this.fecha_hasta.month}-${this.fecha_hasta.day}`;
    }
    const rutas = this.rutasSeleccionadas.map(data => data.id).join();
    if (rutas) {
      queryParams['rutas'] = rutas;
    }

    queryParams['busqueda'] = this.busqueda;
    queryParams['mostrar'] = (this.estado === -1 ? 'todos' : (this.estado === 0 ? 'activos' : 'anulados'));

    this.router.navigate(['./lista/recibos'], { queryParams: queryParams });
  }

  detalleRecibo(recibo) {
    localStorage.setItem('recibo_active', (recibo.ID_RECIBO));
    this.active = recibo.ID_RECIBO;
    this.modals.detalleReciboNgbModal(recibo);
  }

  private initConfigPdf(): void {
    this.prestamoService.obtenerConfiguracionPrestamo()
    .subscribe((res: any) => {
      this.configPdf = {
        direccion: res.direccion_recibo,
        tel: res.telefono_recibo,
        nombre_compania: res.descripcion,
        rnc_compania: res.rnc,
        fax_compania: res.fax,
        email_compania: res.email,
        ciudad_compania: res.ciudad,
        tel_compania: res.telefono,
        direccion_compania: res.direccion
      };
    });
  }

  exportar() {
    if (this.empleadoService.permisosAsignados.filter(a => a.ID_PERMISO == 1).length || this.empleadoService.datosEmpleado.tipo_empleado === 3) {

      if (!this.exportando && this.recibos.length > 0) {
        this.exportando = true;
        const title = `Recibos ${(this.estado === -1 ? '' : (this.estado === 0 ? 'activos' : 'anulados'))}`;
        const columns = [
          {title: 'Cliente', dataKey: '0'},
          {title: 'No.Préstamo', dataKey: '1'},
          {title: 'Cobrador', dataKey: '2'},
          {title: 'Ruta', dataKey: '3'},
          {title: 'Pagado', dataKey: '4'},
          {title: 'Fecha recibo', dataKey: '5'},
        ];
        const rows = [];
        const currencyPipe = new CurrencyPipe('en-US');
        const lowerCasePipe = new LowerCasePipe();
        let fecha_desde = '';
        let fecha_hasta = '';
        if (this.fecha_desde !== undefined && this.fecha_desde !== null && this.fecha_desde.year !== null) {
          fecha_desde = `${this.fecha_desde.year}-${this.fecha_desde.month}-${this.fecha_desde.day}`;
        }
        if (this.fecha_hasta !== undefined && this.fecha_hasta !== null && this.fecha_hasta.year !== null) {
          fecha_hasta = `${this.fecha_hasta.year}-${this.fecha_hasta.month}-${this.fecha_hasta.day}`;
        }
        this.prestamoService.obtenerListaRecibos(
          0,
          0,
          this.rutasSeleccionadas.map(data => data.id).join(),
          this.busqueda,
          fecha_desde,
          fecha_hasta,
          this.estado,
          0,
          '',
          JSON.stringify(this.columnsServer)
        ).subscribe((res: any) => {
          for (const recibo of res.recibos) {
            rows.push(
              {
                '0': this.helper.capitalizeFirstLetter( lowerCasePipe.transform(recibo.cliente) ),
                '1': recibo.ID_PRESTAMO,
                '2': this.helper.capitalizeFirstLetter( lowerCasePipe.transform(recibo.cobrador) ),
                '3': recibo.ID_RUTA,
                '4': currencyPipe.transform(recibo.monto_pagado + recibo.mora),
                '5': (recibo.fecha_registro === '0000-00-00 00:00:00' ? '' : String(recibo.fecha_registro).split('T')[0])
              });
          }

          // Add footer
          rows.push({
            '0': `Total de Recibos: ${rows.length}`,
            '4': currencyPipe.transform(res.recibos.reduce( (a, b) => a + b.monto_pagado + b.mora, 0)),
          });

          const columnStyles = {
            id: {fillColor: 255, textColor: 0},
            1: {columnWidth: 80}
          };

          this.helper.exportarReportePdf(this.configPdf, title, columns, rows, this.empleado.nombreCompleto, columnStyles)
          .then(() => {
            this.exportando = false;
          })
          .catch(() => {
            this.exportando = false;
          });
        }, () => this.exportando = false);
      }
    } else {
      this.modals.validacionesModalJquery('No tienes permisos para realizar esta operación', '',
      'red',
      'modern',
      false,
      'fa fa-thumbs-down');
    }
  }

  anularRecibo(data) {
    if (data.estado !== 1) {

      const html = `¿Estas seguro que quieres anular el recibo <b>${data.ID_RECIBO}</b>?`;
      this.modals.confirmNgbModal(html, 'Anular recibo')
      .then(res => {
        if (res && res === 'si') {
          const label = `¿Por qué quieres anular el recibo <span class="txt-underline">${data.ID_RECIBO}</span>?`;
          this.modals.promptNgbModal('Anular recibo', label)
          .then(resp => {
            if (resp && resp.continue) {

              data.razon_anulado = resp.content;
              this.prestamoService.anularRecibo(data).subscribe(() => {
                this.modals.correctoModalJquery('Recibo anulado con éxito', 'green', 'modern', 'fa fa-file-text');
                this.initRecibos();
              }, err => {
                if (err) {
                  if ([400, 401].includes(err.status)) {
                    this.modals.validacionesModalJquery('No se pudo anular el recibo', err.error,
                    'red',
                    'modern',
                    false,
                    'fa fa-file-text');
                  } else if (err.status == 403) {
                    this.modals.validacionesModalJquery('No tienes permisos para realizar esta operación', '',
                    'red',
                    'modern',
                    false,
                    'fa fa-file-text');
                  }
                }
              });
            }
          });
        }
      });
    }
  }

  navigate(item, tipo: number) {
    localStorage.setItem('recibo_active', (item.ID_RECIBO));

    switch (tipo) {
      case 1:
        this.router.navigate(['/prestamo', item.ID_P]);
      break;
      case 2:
        this.router.navigate(['/cliente', item.ID_C]);
      break;
      case 3:
        this.router.navigate(['/empleado', item.ID_EMPLEADO]);
      break;
    }
  }

  private initColumns(): void {
    this.columnsSort = [
      {
        label: 'No.Recibo',
        column: `r.ID_RECIBO`,
        order: ''
      },
      {
        label: 'No.Préstamo',
        column: 'r.ID_PRESTAMO',
        order: ''
      },
      {
        label: 'Cliente',
        column: 'cliente',
        order: ''
      },
      {
        label: 'Cobrador',
        column: 'cobrador',
        order: ''
      },
      {
        label: 'Zona',
        column: 'rt.ID_RUTA',
        order: ''
      },
      {
        label: 'M.Pagado',
        column: 'pagado',
        order: ''
      },
      {
        label: 'Fecha',
        column: 'r.fecha_registro',
        order: ''
      }
    ];
  }

  orderTable(column) {
    if (!column.order) {
      column.order = 'desc';
    } else {
      column.order = column.order === 'desc' ? 'asc' : 'desc';
    }
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    delete queryParams[`order${column.label.replace(/\s/g, '').toLowerCase()}`];
    queryParams[`order${column.label.replace(/\s/g, '').toLowerCase()}`] = column.order;
    this.router.navigate(['./lista/recibos'], { queryParams: queryParams });
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/recibos/recibos.component.ts